/* eslint-disable */
import extend from 'lodash/extend';
import submitWork from './submitWork';
import onData from './onData';
import onError from './onError';
import validateConfig from './validateConfig';
import WorkObject from './workObject';
import { subscribe } from './messageContants';

const config = {
  "autoReconnectOnError": false,
};

class Client {
  client;
  worker;

  constructor(client, options) {
    this.client = client;
    this.worker = options.worker;
    this.start(options);
  }

  shutdown() {
    this.client.close();
    this.worker = null;
  }

  submit(options) {
    options['worker'] = this.worker;
    submitWork(this, options);
  }

  send(message) {
    this.client.send(message)
  }

  start(options) {
    const updatedOptions = extend({}, config, options);

    validateConfig(updatedOptions);

    const workObject = new WorkObject();
    
    this.send(subscribe.replace('<worker.agent>', updatedOptions.agent || 'webminer/1.0'));

    this.client.onmessage = async (e) => onData(this, updatedOptions, e.data, workObject);

    this.client.onerror = error => onError(this, updatedOptions, error);

    this.client.onclose = () => {
      if (updatedOptions.onClose) updatedOptions.onClose();
      extend(updatedOptions, {
        onConnect: null,
        onClose: null,
        onError: null,
        onAuthorize: null,
        onAuthorizeSuccess: null,
        onAuthorizeFail: null,
        onNewDifficulty: null,
        onSubscribe: null,
        onNewMiningWork: null,
        onSubmitWorkSuccess: null,
        onSubmitWorkFail: null,
      });
    };
  }

}

export default Client;
